import { HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { MomoScheduleDto } from '@app/data/dtos/mot/schedule/momo-schedule.dto';
import { ScheduleDto, ScheduleObservationsDto } from '@app/data/dtos/mot/schedule/schedule.dto';
import { mapMomoSchedule } from '@app/data/mappers/mot/momo-schedule.mapper';
import { mapSchedule, mapScheduleObservations } from '@app/data/mappers/mot/schedule.mapper';
import { ScheduleRepository } from '@app/domain/repositories/mot/schedule.repository.contract';
import { ErrorMsgEnum } from '@app/entities/enums/error/error-msg-enum';
import { MomoSchedule } from '@app/entities/models/mot/schedule/momo-schedule.model';
import { Schedule, ScheduleObservations } from '@app/entities/models/mot/schedule/schedule.model';
import { ENV } from '@environments/environment';
import { SECTION_KEY } from '@services/interceptors/error-sections.interceptor/error-sections.interceptor';

import { MTranslateService } from '@mercadona/core/translate';
import { MRepository } from '@mercadona/core/utils/repository';
@Injectable({
  providedIn: 'root'
})
export class ScheduleRepositoryImpl extends MRepository implements ScheduleRepository {
  private onError = new Subject<ErrorMsgEnum>();
  onError$ = this.onError.asObservable();

  readonly url = '/mot/v2/schedule';
  readonly momoUrl = '/momo/v1/schedule';

  constructor(private translateService: MTranslateService) {
    super(`${ENV.API_URL_MOT}`);
  }

  getSchedule(): Observable<Schedule> {
    let params = new HttpParams();
    params = params.set('lang', this.translateService.getActiveLang());

    return this.get<ScheduleDto>(this.url, { params, context: new HttpContext().set(SECTION_KEY, 'schedule') }).pipe(
      map(mapSchedule)
    );
  }

  getMomoSchedule(): Observable<MomoSchedule> {
    let params = new HttpParams();
    params = params.set('lang', this.translateService.getActiveLang());

    return this.get<MomoScheduleDto>(this.momoUrl, {
      params,
      context: new HttpContext().set(SECTION_KEY, 'momo-schedule')
    }).pipe(map(mapMomoSchedule));
  }

  getMonthlyObservations(year: string, month: string): Observable<ScheduleObservations> {
    const params = new HttpParams()
      .set('year', year)
      .set('month', month)
      .set('lang', this.translateService.getActiveLang());

    return this.get<ScheduleObservationsDto>(`${this.url}/month-info`, { params }).pipe(map(mapScheduleObservations));
  }
}
